// extracted by mini-css-extract-plugin
export var container = "_dk-0";
export var content = "_dk-3";
export var customerTitle = "_dk-4";
export var empty = "_dk-5";
export var gray = "_dk-6";
export var header = "_dk-7";
export var info = "_dk-8";
export var loading = "_dk-2";
export var loadingCard = "_dk-9";
export var oneLine = "_dk-a";
export var personName = "_dk-e";
export var pillContainer = "_dk-b";
export var selected = "_dk-1";
export var text = "_dk-c";
export var twoLines = "_dk-d";
export var unread = "_dk-f";
export var unreadIndicator = "_dk-g";